export default class ObjectService {
    static getPropertyAtPath(obj, path) {
        path = path.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
        path = path.replace(/^\./, ""); // strip a leading dot
        const a = path.split(".");
        for (let i = 0, n = a.length; i < n; ++i) {
            const k = a[i];
            if (k in obj) {
                obj = obj[k];
            }
            else {
                return undefined;
            }
        }
        return obj;
    }
    /**
     * Sets a property at a given path on an object.
     * For example, given an object { a: { b: 1 } } and a path 'a.b', the value 2, the result would be { a: { b: 2 } }
     * */
    static setPropertyAtPath(obj, path, val) {
        path = path.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
        path = path.replace(/^\./, ""); // strip a leading dot
        const keys = path.split(".");
        const lastKey = keys.pop();
        const lastObj = keys.reduce((o, key) => (o[key] || {}), obj);
        lastObj[lastKey] = val;
        return obj;
    }
}
